// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";

export default class FirebaseSettings {

    public enabled: boolean = false;

    public googleCredentialJson: string | null = null;

    public googleWebConfigJson: string | null = null;

    public googleWebVapidKey: string | null = null;

    public readonly isFirebaseSettings: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof FirebaseSettings) || ((from as any).isFirebaseSettings === true));
    }

    public static as(from?: object | null): FirebaseSettings | null {
        return (FirebaseSettings.is(from)) ? from as FirebaseSettings : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(FirebaseSettings, "FirebaseSettings");